'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var AdapterDayjs = require('@mui/x-date-pickers/AdapterDayjs');
var DatePicker = require('@mui/x-date-pickers/DatePicker');
var LocalizationProvider = require('@mui/x-date-pickers/LocalizationProvider');
var dayjs = require('dayjs');
var reactHookForm = require('react-hook-form');
var createFieldControl = require('../lib/form/createFieldControl.js');
var FieldErrors = require('./FieldErrors/FieldErrors.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FIELD_DATE_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldDate on Field_Date {
    __typename
    ...fieldBase
    defaultDate
    fields {
      ...fieldBase
    }
  }
`);
const Field_Date = createFieldControl.createField(FIELD_DATE_FRAGMENT, (field, { methods })=>{
    // const { handle, fields, instructions, label, labelPosition } = field;
    const { defaultDate, handle, label, placeholder, required, instructions } = field;
    // const includeTime = field.fields?.some((field) => field?.handle === 'time');
    const { field: fieldControl, fieldState: { error } } = reactHookForm.useController({
        name: handle,
        control: methods.control,
        // defaultValue: null,
        defaultValue: defaultDate != null ? defaultDate : null
    });
    const fieldProps = {
        label,
        value: dayjs(fieldControl.value),
        slotProps: {
            textField: {
                required,
                helperText: instructions,
                placeholder,
                // ...fieldControl,
                error: !!error
            }
        }
    };
    const handleChange = (value, _context)=>{
        var _value_format;
        fieldControl.onChange((_value_format = value == null ? void 0 : value.format('YYYY-MM-DD')) != null ? _value_format : null);
    };
    return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(LocalizationProvider.LocalizationProvider, {
                dateAdapter: AdapterDayjs.AdapterDayjs,
                children: /*#__PURE__*/ jsxRuntime.jsx(DatePicker.DatePicker, _extends({}, fieldProps, {
                    onChange: handleChange
                }))
            }),
            /*#__PURE__*/ jsxRuntime.jsx(FieldErrors, {
                errors: error
            })
        ]
    });
});

module.exports = Field_Date;
